import axios from "axios";

const uncoveryApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

const requestHandler = (request) => {
  const token = localStorage.getItem("accessToken");

  if (token) {
    request.headers["Authorization"] = `Bearer ${token}`;
  } else {
    delete request.headers["Authorization"];
  }
  return request;
};

uncoveryApi.interceptors.request.use((request) => requestHandler(request));

const responseSuccessHandler = (response) => {
  return response;
};

const responseErrorHandler = (error) => {
  if (error.response.status === 401) {
    localStorage.removeItem("accessToken");
    window.location = "/signin";
  }
  return Promise.reject(error);
};

uncoveryApi.interceptors.response.use(
  (response) => responseSuccessHandler(response),
  (error) => responseErrorHandler(error)
);

export { uncoveryApi };
